import { tv } from 'tailwind-variants';

export const dividerVariants = tv({
  base: ['bg-grey-400', 'border-grey-400'],
  variants: {
    orientation: {
      horizontal: ['w-full', 'h-px'],
      vertical: ['w-px', 'h-6']
    }
  },
  defaultVariants: {
    orientation: 'horizontal'
  }
});
